/* global _wq */

export default {

    init: function () {
        this.bindEvents();
    },

    play: function (id) {
        _wq.push({
            id: id, onReady: function (video) {
                video.play();
                $(window).trigger('Wistia/ready/' + id);
            },
        });
    },

    bindEvents: function () {

        let _this = this;

        $('*[data-wistia-play]').click(function () {
            _this.play($(this).data('wistia-play'));

            $(this).children('.video-title').removeClass('visible');
        });

        $(window).on('Wistia/play', function (e, data) {
            _this.play(data.id);
        })
    },
}
